import { Injectable } from '@angular/core';
import {
  EditMyOwnSubordinatesHierarchyInput,
  EditStaffSubordinatesHierarchyInput,
  StaffSubordinatesHierarchiesServiceProxy,
  StaffSubordinatesHierarchyDto,
  StaffSubordinatesServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Injectable({
  providedIn: 'root',
})
export class DirectReportsFacade {
  constructor(
    private _staffSubordinatesProxy: StaffSubordinatesHierarchiesServiceProxy
  ) {}

  EditStaffSubordinatesHierarchyInput(
    doNotHaveSubordinates,
    selectedSubordinates,
    superiorStaffId
  ) {
    let params = new EditStaffSubordinatesHierarchyInput({
      staffSubordinatesHierarchyHierarchy: new StaffSubordinatesHierarchyDto({
        doNotHaveSubordinates,
        subordinateStaffIds: selectedSubordinates,
      }),
      superiorStaffId,
    });

    return this._staffSubordinatesProxy.updateSubordinatesHierarchy(params);
  }

  EditMyOwnSubordinatesHierarchyInput(
    doNotHaveSubordinates,
    selectedSubordinates
  ) {
    let params = new EditMyOwnSubordinatesHierarchyInput({
      staffSubordinatesHierarchyHierarchy: new StaffSubordinatesHierarchyDto({
        doNotHaveSubordinates,
        subordinateStaffIds: selectedSubordinates,
      }),
    });

    return this._staffSubordinatesProxy.updateMyOwnSubordinatesHierarchy(
      params
    );
  }
}
